module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-02.3ff4f1f7.jpg";